import React from 'react';
import {Col, Row} from 'react-bootstrap';
import Switch from 'react-switch';

const DefaultTrigger = ({ toggle_dropdown, is_triggered, title, col_width_switch, col_width_title }) => (
	<Row style={{ padding: 5 }}>
		<Row style={{ backgroundColor: '#dcd9db', boxShadow: '0 5px 20px 0 rgba(0,0,0,0.1)', borderRadius:6, padding: 7, cursor: 'pointer' }}>
			<Col xs={col_width_title ? col_width_title : 9} style={{fontWeight:'bold',textAlign:'left'}}>
				{title}
			</Col>
			<Col xs={col_width_switch ? col_width_switch : 3} className="text-right">
				<Switch 
					onChange={toggle_dropdown} 
					checked={is_triggered} 
					height={22} 
					width={46} 
					handleDiameter={16} 
					onColor="#ff841f" 
					checkedIcon={false}
					uncheckedIcon={false}
				/>
			</Col>
		</Row>
	</Row>	
)

const defaultTriggerOnClick = () => {
	console.log('hi')
}

const DefaultDropper = () => (
	<div>Hello world !! I'm the default dropper</div>
)

const Switcher = ({ Trigger, Dropper, dropper_container_style, container_style, trigger_on_click, show_dropper, title, col_width_title, col_width_switch }) => {
	try {
		return (
			<div style={{ position: 'relative', ...container_style }}>
				<Trigger 
					toggle_dropdown={trigger_on_click}
					is_triggered={show_dropper}
					title={title}
					col_width_switch={col_width_switch}
					col_width_title={col_width_title}
				/>
				<div style={{ display: show_dropper ? 'block' : 'none', ...dropper_container_style }}> 
					<Dropper />
				</div>
			</div>
		);
	} catch(err) {
		console.log('erorr in Switcher --<>>>>>', err);
		return '';
	}
}

Switcher.defaultProps = {
	Trigger: DefaultTrigger,
	Dropper: DefaultDropper,
	container_style: {},
	dropper_container_style: {},
	title: '',
	trigger_on_click: defaultTriggerOnClick
}

export default Switcher;